export default function OptionGroup({ group, options, value, onSelect }) {
  return (
    <div className="mt-1.5 grid grid-cols-1 gap-2.5 sm:grid-cols-2" data-group={group}>
      {options.map((opt) => {
        const label = typeof opt === 'string' ? opt : opt.label
        const val = typeof opt === 'string' ? opt : opt.value
        const selected = value === val
        return (
          <button
            key={val}
            type="button"
            data-v={val}
            onClick={() => onSelect(group, val)}
            className={`rounded-[10px] border-[1.5px] px-[15px] py-[13px] text-left font-[inherit] text-[14.5px] transition-colors duration-150 ${
              selected
                ? 'border-[var(--ink-blue)] bg-[rgba(27,68,224,.04)] font-medium text-[var(--ink)]'
                : 'border-[var(--line)] bg-white text-[var(--ink-2)] hover:border-[var(--line-2)]'
            }`}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
